/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import nofileSvg from "../../../../public/nofile.svg";
import ToastService from "../../../../services/ToastService";
import MasterService from "../../../../services/MasterService";
import CountryService from "../../../../services/CountryService";
import { showLoading } from "react-global-loading";

class AddEditCountry extends React.Component {
  constructor(props) {
    super(props);
    const query = this.props.location?.search
      ? new URLSearchParams(this.props.location.search)
      : "";

    this.state = {
      countryId: query ? query.get("id") : "",
      missionName: "",
      embassyPerson: "",
      phoneno: "",
      selectedCountry: "",
      missionAddress: "",
      embassyName: "",
      emailId: "",
      imageApi: "",
      remarks: "",
      categories: [],
      countries: [],
      ayushCountries: [],
      selectedCategory: [],
      rulesNRegulation: "",
      links: "", countryDesc: '',
      infoCell: "", mouUpload: '', rulesRegulationUpload: '', infoCellUpload: '', ayushChairUpload: '', ayushChair: '',
      opportunity: '', opportunityUpload: '', mou: '', errors: {}
    };
  }

  componentDidMount = () => {
    this.state.countryId ? this.getCountryDetails() : "";
    this.getCategories();
    this.getAllCountries();
    this.getRegisteredCountries();
  };

  getCountryDetails = () => {
    MasterService.getCountryDetails(this.state.countryId)
      .then(result => {
        if (!result) {
          return;
        }

        this.setState({
          countryDetails: result[0],
          missionName: result[0].post_title,
          embassyPerson: result[0].embassy_person,
          phoneno: result[0].phone,
          missionAddress: result[0].mission_address,
          embassyName: result[0].embassy_name,
          emailId: result[0].email,
          selectedCategory: result[0].domains[0],
          selectedCountry: result[0].select_country,
          imageApi: result[0].mission_image,
          editId: result[0].ID,
          remarks: result[0].remark,
          countryDesc: result[0].post_content,
          mou: result[0].mou,
          links: result[0].important_links,
          rulesNRegulation: result[0].rules_regulation,
          opportunity: result[0].opportunity,
          ayushChair: result[0].ayush_chair,
          infoCell: result[0].info_cell,
        });

        showLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  };

  getRegisteredCountries = () => {
    MasterService.getAyushCountries()
      .then(result => {
        if (!result) return;

        this.setState({ ayushCountries: result });
      })
      .catch(err => {
        console.error(err);
      });
  };

  getAllCountries = () => {
    MasterService.getCountries()
      .then(result => {
        if (!result) {
          return;
        }
        this.setState({ countries: result });
      })
      .catch(err => {
        console.error(err);
      });
  };

  getCategories = () => {
    MasterService.getCategories()
      .then(result => {
        if (!result) {
          return;
        }
        this.setState({ categories: result });
      })
      .catch(err => {
        console.error(err);
      });
  };

  deleteImage() {
    this.setState({ imageApi: "" });
    // this.setState({
    //   selectedImages: this.state.selectedImages.filter(image => image.thumbnail ===
    //     'https://picsum.photos/id/1019/250/150/')
    // });

    // const idx = this.state.selectedImages.getCurrentIndex();
    // this.state.selectedImages.slideToIndex(idx === 0 ? idx : idx - 1);
  }

  handleCategories = (status, catId) => {
    if (status === true) {
      this.setState({
        selectedCategory: [...this.state.selectedCategory, catId],
      });
    } else {
      this.setState({
        selectedCategory: this.state.selectedCategory.filter(
          item => item !== catId,
        ),
      });
    }
  };

  onImageSelection = event => {
    this.setState({
      selectedImages: [
        {
          original: URL.createObjectURL(event.target.files[0]),
          thumbnail: URL.createObjectURL(event.target.files[0]),
        },
      ],
      imageApi: event.target.files[0], // [...this.state.imageApi, event.target.files[0]]
    });
  };

  onCountryCreateUpdate = () => {
    const {
      missionName,
      embassyPerson,
      phoneno,
      selectedCountry,
      missionAddress,
      embassyName,
      emailId,
      selectedCategory,
      imageApi,
      remarks,
      countryDesc,
      countryId,
      editId,
      infoCell,
      rulesNRegulation,
      mou,
      links, mouUpload, rulesRegulationUpload, infoCellUpload, ayushChair, ayushChairUpload, opportunity, opportunityUpload
    } = this.state;
    if (this.validate('all')) {
      if (
        missionName &&
        phoneno &&
        embassyPerson &&
        imageApi &&
        (selectedCountry || editId) &&
        emailId
      ) {
        const emailregex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        const mobPattern = /^[+]?\d+$/;

        if (
          !mobPattern.test(phoneno) &&
          !(phoneno.length >= 10 && phoneno.length < 16)
        )
          return ToastService.error("Please enter valid mobile");

        if (!emailregex.test(emailId))
          return ToastService.error("Please enter valid email");

        const data = new FormData();
        data.append("mission_name", missionName);
        data.append("embassy_name", embassyName);
        data.append("embassy_person", embassyPerson);
        data.append("email", emailId);
        data.append("phone_no", phoneno);
        data.append("category", selectedCategory);
        data.append("country_desc", countryDesc);
        data.append("remark", remarks);
        data.append("image_upload", imageApi);
        data.append("mission_address", missionAddress);
        data.append("select_country", selectedCountry);
        data.append("mou", mou);
        data.append("rules_regulation", rulesNRegulation);
        data.append("links", links);
        data.append("info_cell", infoCell);
        data.append("rules_regulation_upload", rulesRegulationUpload);
        data.append("mou_upload", mouUpload);
        data.append("ayushChair_upload", ayushChairUpload);
        data.append("opportunity_upload", opportunityUpload);
        data.append("ayush_chair", ayushChair);
        data.append("opportunity", opportunity);
        data.append("info_cell_upload", infoCellUpload);
        data.append("lang", localStorage.getItem('localLang'));
        data.append("ID", countryId ? editId : "");

        if (countryId) {
          CountryService.updateCountry(data).then(result => {
            showLoading(true);
            result.status === 200
              ? (ToastService.success(result.data.message),
                showLoading(false),
                window.location.reload())
              : (ToastService.error(result.data.message), showLoading(false));
          });
        } else {
          showLoading(true);
          CountryService.addCountry(data).then(result => {
            result.status === 200
              ? (ToastService.success(result.data.message),
                showLoading(false),
                window.location.reload()
              )
              : (ToastService.error(result.data.message), showLoading(false));
          });
        }
      } else {
        return ToastService.error("Please fill required details");
      }
    }
    else {
      ToastService.error("Please fix validation errors before submitting.");
    }

  };

  onDocSelection = event => {
    this.setState({
      docApi: event.target.files[0], // [...this.state.docApi, event.target.files[0]]
    });
  };

  handleLinks = (e) => {
    const linkRegex =
      /[-a-zA-Z0-9@:%_.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_.~#?&//=]*)?/gi;

    if (e.target.value && !linkRegex.test(e.target.value))
      return ToastService.error("Please enter valid link");
  };

  handleBlur = (e) => {
    const { name } = e.target;
    this.validate(name);
  };

  validate = (field) => {
    const {
      missionName,
      missionAddress,
      embassyName,
      embassyPerson,
      emailId,
      phoneno,
      countryDesc,
      rulesNRegulation,
      links,
      infoCell,
      mou,
      opportunity,
      ayushChair,
      remarks,
      errors
    } = this.state;

    let updatedErrors = {};

    // Character limit validation
    if (field === 'missionName' || field === 'all') {
      if (missionName.length > 50) {
        updatedErrors.missionName = "Mission Name cannot exceed 50 characters.";
      } else if (!/^[a-zA-Z\s]*$/.test(missionName)) { // No special characters validation
        updatedErrors.missionName = "Mission Name cannot contain special characters.";
      }
    }

    if (field === 'embassyName' || field === 'all') {
      if (!/^[a-zA-Z\s]*$/.test(embassyName)) {
        updatedErrors.embassyName = "Embassy Name cannot contain special characters.";
      }
    }

    // Phone number validation (10 digits)
    const phoneRegex = /^[0-9]{10}$/;
    if (field === 'phoneno' || field === 'all') {
      if (!phoneRegex.test(phoneno)) {
        updatedErrors.phoneno = "Phone number must be 10 digits.";
      }
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (field === 'emailId' || field === 'all') {
      if (!emailRegex.test(emailId)) {
        updatedErrors.emailId = "Invalid email format.";
      }
    }

    // URL validation for links
    const linkRegex = /^(https?|chrome):\/\/[^\s$.?#].[^\s]*$/;
    if (field === 'links' || field === 'all') {
      if (links && !linkRegex.test(links)) {
        updatedErrors.links = "Invalid URL.";
      } else if (!/^[a-zA-Z0-9\s]*$/.test(links)) {
        updatedErrors.links = "Links cannot contain special characters.";
      }
    }

    // No special characters validation for specific fields
    const alphanumericPattern = /^[a-zA-Z0-9\s]*$/;

    if (field === 'rulesNRegulation' || field === 'all') {
      if (!alphanumericPattern.test(rulesNRegulation)) {
        updatedErrors.rulesNRegulation = "Rules & Regulations cannot contain special characters.";
      }
    }

    if (field === 'infoCell' || field === 'all') {
      if (!alphanumericPattern.test(infoCell)) {
        updatedErrors.infoCell = "Ayush Information Cell cannot contain special characters.";
      }
    }

    if (field === 'ayushChair' || field === 'all') {
      if (!alphanumericPattern.test(ayushChair)) {
        updatedErrors.ayushChair = "Ayush Chairs cannot contain special characters.";
      }
    }

    if (field === 'opportunity' || field === 'all') {
      if (!alphanumericPattern.test(opportunity)) {
        updatedErrors.opportunity = "Opportunities for Students cannot contain special characters.";
      }
    }

    // No special characters for `mou`, `countryDesc`, `missionAddress`, and `remarks`
    if (field === 'mou' || field === 'all') {
      if (!alphanumericPattern.test(mou)) {
        updatedErrors.mou = "MoU cannot contain special characters.";
      }
    }

    if (field === 'countryDesc' || field === 'all') {
      if (!alphanumericPattern.test(countryDesc)) {
        updatedErrors.countryDesc = "Country Description cannot contain special characters.";
      }
    }

    if (field === 'missionAddress' || field === 'all') {
      if (!alphanumericPattern.test(missionAddress)) {
        updatedErrors.missionAddress = "Mission Address cannot contain special characters.";
      }
    }

    if (field === 'remarks' || field === 'all') {
      if (!alphanumericPattern.test(remarks)) {
        updatedErrors.remarks = "Special remarks cannot contain special characters.";
      }
    }

    // Character limit validations for fields
    if (field === 'missionAddress' || field === 'all') {
      if (missionAddress.length > 500) {
        updatedErrors.missionAddress = "Mission Address cannot exceed 500 characters.";
      }
    }

    if (field === 'countryDesc' || field === 'all') {
      if (countryDesc.length > 500) {
        updatedErrors.countryDesc = "Country Description cannot exceed 500 characters.";
      }
    }

    if (field === 'mou' || field === 'all') {
      if (mou.length > 500) {
        updatedErrors.mou = "MoU cannot exceed 500 characters.";
      }
    }

    if (field === 'remarks' || field === 'all') {
      if (remarks.length > 500) {
        updatedErrors.remarks = "Special remarks cannot exceed 500 characters.";
      }
    }

    // Update state with errors
    this.setState({ errors: updatedErrors });

    // Return true if there are no errors
    return Object.keys(updatedErrors).length === 0;
  };



  render() {
    const {
      categories,
      countries,
      selectedCategory,
      missionName,
      selectedCountry,
      missionAddress,
      emailId,
      ayushCountries,
      imageApi,
      remarks,
      embassyName,
      embassyPerson,
      phoneno,
      countryDesc,
      countryId,
      rulesNRegulation,
      links,
      infoCell, ayushChair, opportunity, ayushChairUpload, opportunityUpload,
      mou, mouUpload, rulesRegulationUpload, infoCellUpload, errors
    } = this.state;

    return (
      <>
        <div className="container-fluid" id={countryId ? "main" : ""}>
          <div
            id="#add-new-country-tab"
            className="row bg-secondary-subtle p-2 group-btn"
          >
            {/* <div className="col-12 d-flex align-items-center">
              <h4 >Please select the Country below :- </h4>
            </div> */}
            {/* <div className="col-md-6 text-end float-end">
              <button type="button" className="btn theme-btn-fill update-country-btn"><i className="fa fa-plus-circle" aria-hidden="true"></i> Add Country</button>
            </div> */}
            {/* <div className="tab-pane fade active show" id="add-new-country-pane" role="tabpanel" aria-labelledby="#add-new-country-tab" style="font-size: 16px;"></div> */}
          </div>
          {!countryId && (
            <div className="row mt-4">
              <div className="col-12">
                <div className="form-group mb-4 position-relative">
                  <select
                    name="orderby"
                    className="form-control"
                    aria-label="select order"
                    value={selectedCountry}
                    onChange={e =>
                      this.setState({ selectedCountry: e.target.value })
                    }
                  >
                    <option defaultValue="selected">Countries*</option>
                    {countries.map((item, index) => (
                      <option
                        key={index}
                        value={item.id}
                        disabled={
                          ayushCountries.findIndex(
                            registerItem => registerItem.id === item.id,
                          ) === -1
                            ? false
                            : true
                        }
                      >
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          )}

          {selectedCountry || countryId ? (
            <>
              <div className="rowfl p-2 group-btn mt-4">
                <div className="d-flex align-items-center ">
                  <h5>Please fill the Country details below : </h5>
                </div>
                {/* <div className="nopd text-end float-end">

                    <button type="button" className="btn theme-btn-outline discard"><i className="fa fa-minus-circle" aria-hidden="true"></i> Discard Changes</button>
                    <button onClick={() => this.onCountryCreateUpdate()} className="btn adprdcard"><i className="fa fa-plus-circle" aria-hidden="true"></i> {countryId ? "Edit" : "Save"} Country</button>
                  </div> */}
              </div>
              <div className="row mt-3">
                <div className="col-md-8 mt-4">
                  <div className="form-group mb-4 position-relative">
                    <label
                      htmlFor="ayushmissionname"
                      id="missionname"
                      className="bldlbl"
                    >
                      Ayush Mission Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      aria-labelledby="missionname"
                      placeholder="Enter Ayush Mission name"
                      name="missionName"
                      onBlur={this.handleBlur}
                      onChange={e =>
                        this.setState({ missionName: e.target.value })
                      }
                      value={missionName}
                    />
                    {errors.missionName && <span className="text-danger">{errors.missionName}</span>}
                  </div>
                  <div className="form-group mb-4 position-relative">
                    <label
                      htmlFor="missionaddress"
                      id="missionaddrs"
                      className="bldlbl"
                    >
                      Mission Address
                    </label>
                    <textarea
                      className="form-control textarea-height"
                      aria-labelledby="missionaddrs"
                      name="missionAddress"
                      rows="3"
                      placeholder="Enter the mission’s address"
                      onBlur={this.handleBlur}
                      onChange={e =>
                        this.setState({ missionAddress: e.target.value })
                      }
                      value={missionAddress}
                    />
                    {errors.missionAddress && <span className="text-danger">{errors.missionAddress}</span>}
                  </div>
                  <div className="form-group mb-4 position-relative">
                    <label
                      htmlFor="embassyname"
                      id="embassyyname"
                      className="bldlbl"
                    >
                      Embassy Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      aria-labelledby="embassyyname"
                      placeholder="Enter the embassy name"
                      name="embassyName"
                      onBlur={this.handleBlur}
                      onChange={e =>
                        this.setState({ embassyName: e.target.value })
                      }
                      value={embassyName}
                    />
                    {errors.embassyName && <span className="text-danger">{errors.embassyName}</span>}

                  </div>
                  <div className="form-group mb-4 position-relative">
                    <label
                      htmlFor="contactname"
                      id="contactperson"
                      className="bldlbl"
                    >
                      Contact Person in Embassy <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      aria-labelledby="contactperson"
                      placeholder="Contact Person in Embassy"
                      name="embassyPerson"
                      onBlur={this.handleBlur}
                      onChange={e =>
                        this.setState({ embassyPerson: e.target.value })
                      }
                      value={embassyPerson}
                    />
                    {errors.embassyPerson && <span className="text-danger">{errors.embassyPerson}</span>}

                  </div>
                  <div className="form-group mb-4 position-relative">
                    <label htmlFor="Contactemail" id="email" className="bldlbl">
                      E-mail <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      aria-label="email"
                      name="emailId"
                      placeholder="Enter the E-mail"
                      onBlur={this.handleBlur}
                      onChange={e => this.setState({ emailId: e.target.value })}
                      value={emailId}
                    />
                    {errors.emailId && <span className="text-danger">{errors.emailId}</span>}

                  </div>
                  <div className="form-group mb-4 position-relative">
                    <label htmlFor="contactphone" id="phonm" className="bldlbl">
                      Phone Number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      aria-labelledby="phonm"
                      name="phoneno"
                      placeholder="Enter the Phone Number"
                      onBlur={this.handleBlur}
                      onChange={e => this.setState({ phoneno: e.target.value })}
                      value={phoneno}
                    />
                    {errors.phoneno && <span className="text-danger">{errors.phoneno}</span>}

                  </div>
                  <div className="form-group mb-4 position-relative">
                    <label
                      htmlFor="domiancountry"
                      id="domanss"
                      className="bldlbl"
                    >
                      <b>Domains practiced across country:</b>
                    </label>
                    <div
                      className="btn-group d-block event-check"
                      role="group"
                      aria-label="select domain"
                    >
                      {categories.map((item, index) => (
                        <span key={index}>
                          {" "}
                          <input
                            aria-labelledby="domanss"
                            type="checkbox"
                            className="btn-check"
                            id={index}
                            autoComplete="off"
                            onClick={e =>
                              this.handleCategories(e.target.checked, item.name)
                            }
                            checked={selectedCategory?.includes(item.name)}
                          />
                          <label
                            className="btn btn-outline-dark "
                            htmlFor={index}
                          >
                            {item.name}
                          </label>
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="form-group mb-4 position-relative">
                    <label
                      htmlFor="specialremarks"
                      id="cntrydesc"
                      className="bldlbl"
                    >
                      Country Description
                    </label>
                    <textarea
                      className="form-control textarea-height"
                      aria-labelledby="cntrydesc"
                      placeholder="Enter description"
                      name="countryDesc"
                      rows="3"
                      onBlur={this.handleBlur}
                      onChange={e =>
                        this.setState({ countryDesc: e.target.value })
                      }
                      value={countryDesc}
                    />
                    {errors.countryDesc && <span className="text-danger">{errors.countryDesc}</span>}

                  </div>

                  <div className="dividr"></div>

                  <div className="form-group mb-4 position-relative">
                    <label
                      htmlFor="specialremarks"
                      id="cntrydesc"
                      className="bldlbl"
                    >
                      Rules & Regulations
                    </label>
                    <textarea
                      className="form-control textarea-height"
                      aria-labelledby="cntrydesc"
                      placeholder="Enter rules and regulations"
                      name="rulesNRegulation"
                      rows="3"
                      onBlur={this.handleBlur}
                      onChange={e =>
                        this.setState({ rulesNRegulation: e.target.value })
                      }
                      value={rulesNRegulation}
                    />
                    {errors.rulesNRegulation && <span className="text-danger">{errors.rulesNRegulation}</span>}

                    <input
                      aria-labelledby="uploaddocument"
                      id="uploaddocument"
                      type="file"
                      name="file"
                      class="form-control flmr"
                      accept="application/pdf"
                      onChange={(e) => this.setState({ rulesRegulationUpload: e.target.files[0] })}
                    />
                  </div>

                  <div className="dividr"></div>

                  <div className="form-group mb-4 position-relative">
                    <label
                      htmlFor="specialremarks"
                      id="links"
                      className="bldlbl"
                    >
                      Important Links
                    </label>
                    <textarea
                      className="form-control textarea-height"
                      aria-labelledby="links"
                      placeholder="Enter links"
                      name="links"
                      rows="3"
                      onBlur={this.handleBlur}
                      onChange={e => this.setState({ links: e.target.value })}
                      onClick={e => this.handleLinks(e)}
                      value={links}
                    />
                    {errors.links && <span className="text-danger">{errors.links}</span>}

                  </div>

                  <div className="dividr"></div>

                  <div className="form-group mb-4 position-relative">
                    <label
                      htmlFor="specialremarks"
                      id="cntrydesc"
                      className="bldlbl"
                    >
                      Ayush Information Cell
                    </label>
                    <textarea
                      className="form-control textarea-height"
                      aria-labelledby="cntrydesc"
                      placeholder="Enter Ayush Information Cell"
                      name="infoCell"
                      rows="3"
                      onBlur={this.handleBlur}
                      onChange={e =>
                        this.setState({ infoCell: e.target.value })
                      }
                      value={infoCell}
                    />
                    {errors.infoCell && <span className="text-danger">{errors.infoCell}</span>}

                    <input
                      aria-labelledby="uploaddocument"
                      id="uploaddocument"
                      class="form-control flmr"
                      type="file"
                      name="file"
                      accept="application/pdf"
                      onChange={(e) => this.setState({ infoCellUpload: e.target.files[0] })}
                    />
                  </div>

                  <div className="dividr"></div>

                  <div className="form-group mb-4 position-relative">
                    <label
                      htmlFor="specialremarks"
                      id="cntrydesc"
                      className="bldlbl"
                    >
                      MoU
                    </label>
                    <textarea
                      className="form-control textarea-height"
                      aria-labelledby="cntrydesc"
                      placeholder="Enter MoU"
                      name="mou"
                      rows="3"
                      onBlur={this.handleBlur}
                      onChange={e =>
                        this.setState({ mou: e.target.value })
                      }
                      value={mou}
                    />
                    {errors.mou && <span className="text-danger">{errors.mou}</span>}

                    <input
                      aria-labelledby="uploaddocument"
                      id="uploaddocument"
                      class="form-control flmr"
                      type="file"
                      name="file"
                      accept="application/pdf"
                      onChange={(e) => this.setState({ mouUpload: e.target.files[0] })}
                    />
                  </div>
                  <div className="dividr"></div>

                  <div className="form-group mb-4 position-relative">
                    <label
                      htmlFor="specialremarks"
                      id="cntrydesc"
                      className="bldlbl"
                    >
                      Opportunity for Students
                    </label>
                    <textarea
                      className="form-control textarea-height"
                      aria-labelledby="cntrydesc"
                      placeholder="Enter Opportunity for Students"
                      name="opportunity"
                      rows="3"
                      onBlur={this.handleBlur}
                      onChange={e =>
                        this.setState({ opportunity: e.target.value })
                      }
                      value={opportunity}
                    />
                    {errors.opportunity && <span className="text-danger">{errors.opportunity}</span>}

                    <input
                      aria-labelledby="uploaddocument"
                      id="uploaddocument"
                      class="form-control flmr"
                      type="file"
                      name="file"
                      accept="application/pdf"
                      onChange={(e) => this.setState({ opportunityUpload: e.target.files[0] })}
                    />
                  </div>
                  <div className="dividr"></div>

                  <div className="form-group mb-4 position-relative">
                    <label
                      htmlFor="specialremarks"
                      id="cntrydesc"
                      className="bldlbl"
                    >
                      Ayush Chairs
                    </label>
                    <textarea
                      className="form-control textarea-height"
                      aria-labelledby="cntrydesc"
                      placeholder="Enter Ayush Chairs"
                      name="ayushChair"
                      rows="3"
                      onBlur={this.handleBlur}
                      onChange={e =>
                        this.setState({ ayushChair: e.target.value })
                      }
                      value={ayushChair}
                    />
                    {errors.ayushChair && <span className="text-danger">{errors.ayushChair}</span>}

                    <input
                      aria-labelledby="uploaddocument"
                      id="uploaddocument"
                      class="form-control flmr"
                      type="file"
                      name="file"
                      accept="application/pdf"
                      onChange={(e) => this.setState({ ayushChairUpload: e.target.files[0] })}
                    />
                  </div>
                  <div className="form-group mb-4 position-relative">
                    <label
                      htmlFor="specialremarks"
                      id="spclremarks"
                      className="bldlbl"
                    >
                      Special remarks
                    </label>
                    <textarea
                      className="form-control textarea-height"
                      aria-labelledby="spclremarks"
                      name="remarks"
                      rows="3"
                      onBlur={this.handleBlur}
                      onChange={e => this.setState({ remarks: e.target.value })}
                      value={remarks}
                      placeholder="Enter remarks"
                    />
                    {errors.remarks && <span className="text-danger">{errors.remarks}</span>}

                  </div>
                </div>
                <div className="col-md-4 mt-4">
                  <p>Country’s Flag:</p>
                  <div className="upload-drag d-flex align-items-center justify-content-center">
                    {imageApi ? (
                      <img
                        src={imageApi[0] || URL.createObjectURL(imageApi)}
                        className="imgcon"
                      />
                    ) : (
                      <div className="uploadbox">
                        <img
                          src={nofileSvg}
                          className="d-block noimg"
                          alt="upload"
                        />
                        <span className="d-block">
                          Upload Image by clicking{" "}
                        </span>
                        <label
                          htmlFor="productname"
                          id="uploadimagg"
                          className="bldlbl"
                        >
                          Image of the country flag <span className="text-danger">*</span>
                        </label>
                        <input
                          className="upload-btn"
                          type="file"
                          name="file"
                          aria-labelledby="uploadimagg"
                          accept=".png, .jpg, .jpeg"
                          onChange={this.onImageSelection}
                        />
                      </div>
                    )}

                    {imageApi && (
                      <div className="d-block del-btn">
                        <button onClick={() => this.deleteImage()}>
                          <i className="fa fa-trash" aria-hidden="true"></i>
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="rowfl_btm bg-secondary-subtle p-2 group-btn mt-4">
                {/* <div className="nopd d-flex align-items-center ">
                    <h4>Please fill the Country details below :- </h4>
                  </div> */}
                <div className="nopd text-end float-end">
                  <button
                    type="button"
                    className="btn theme-btn-outline discard"
                  >
                    <i className="fa fa-minus-circle" aria-hidden="true"></i>{" "}
                    Discard Changes
                  </button>
                  <button
                    onClick={() => this.onCountryCreateUpdate()}
                    className="btn adprdcard"
                  >
                    <i className="fa fa-plus-circle" aria-hidden="true"></i>{" "}
                    {countryId ? "Edit" : "Save"} Country
                  </button>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </>
    );
  }
}
export default AddEditCountry;
